import React, { useEffect, useState } from 'react'
import { Error, LoadingSpinner } from '../../components'
import getAuth0 from '../../utils/auth0'
import handleCallback from '../../utils/auth0/handleCallback'
import { newRelicTriggerSuccessEvent, newRelicTriggerErrorEvent } from '../../utils/newrelic'
import { triggerErrorEvent, triggerEvent } from '../../utils/analytics'

type Props = {
  location: {
    search: string
  }
}

export default function BrowseCallback({ location: { search } }: Props): JSX.Element {
  const [error, setError] = useState<{ code: string } | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        triggerEvent('browseCallbackPageLoad')
        const params = new URLSearchParams(search)
        const auth0 = getAuth0()
        const continueTo = params.get('continueTo') || window.location.origin
        await handleCallback()
        await auth0.atg.extendSession()
        const token = await auth0.getIdTokenClaims()
        newRelicTriggerSuccessEvent('browse-callback')
        const url =
          token['https://www.johnlewis.com/auth/isRegistration'] === 'true'
            ? `${window.auth.ACCOUNT_URL}/account-created?continueUrl=${continueTo}`
            : continueTo
        window.location.replace(url)
      } catch (error) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-callback', error)
        triggerErrorEvent(error.message)
        setError({ code: 'browse.callback.error' })
      }
    })()
  }, [])

  return <div data-test="browse-callback">{error ? <Error /> : <LoadingSpinner />}</div>
}
